import React from "react";
import { ROLES, useRoles } from "../hooks/useRoles";
import type { MODULES } from "./sideBarItems";
import { Navigate, Outlet } from "react-router-dom";

interface ProtectedRouteProps {
  required?: (MODULES | ROLES)[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  required = [],
}) => {
  const { roles } = useRoles();

  const userPerms = new Set([...roles]);
  const hasAccess =
    required.length === 0 || required.some((r) => userPerms.has(r));

  if (!hasAccess) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
};
